/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { withMyTheme } from '../theme/theme';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { isMobile, mobileCss } from '../util/isMobile';
import { isTablet, tabletCss } from '../util/isTablet';

const LanguageSelectorContainerStyle = withMyTheme(() => css`
  display: flex;
  align-items: center;
  gap: 10px;
`);

const LanguageButtonStyle = withMyTheme((theme) => css`
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-family: ${theme.typography.body1.fontFamily};
  position: relative;
  color: ${isMobile() || isTablet() ? 'white' : theme.palette.text.primary};
  opacity: 0.6;
  
  &.active {
    opacity: 1;
    color: ${theme.palette.primary.main};
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: ${theme.palette.primary.main};
    }
  }
  
  &:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.04);
  }
`);

const DividerStyle = withMyTheme((theme) => css`
  width: 1px;
  height: 16px;
  background-color: ${theme.palette.divider};
`);

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  
  // Update state when i18n language changes
  useEffect(() => {
    const handleLanguageChanged: any = () => {
      setCurrentLanguage(i18n.language);
    };
    
    // Subscribe to language change events
    i18n.on('languageChanged', handleLanguageChanged);
    
    // Initialize with current language
    setCurrentLanguage(i18n.language);
    
    // Cleanup subscription on unmount
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);
  
  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div css={LanguageSelectorContainerStyle}>
      <button
        css={LanguageButtonStyle}
        className={currentLanguage.includes('en') ? 'active' : ''}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
      <div css={DividerStyle} />
      <button
        css={LanguageButtonStyle}
        className={currentLanguage.includes('pl') ? 'active' : ''}
        onClick={() => changeLanguage('pl')}
      >
        PL
      </button>
    </div>
  );
};
